import { ReactElement, useEffect, useState } from 'react';
import { Loading } from '@betrybe/ada-react';
import { useHistory, useLocation } from 'react-router-dom';
import { DefaultLayout, SimpleLayout } from '@/layouts';
import { InfoGroup } from '@/components/molecules';
import { useAuthentication, useToken } from '@/hooks';

function Home(): ReactElement {
  const { authenticated } = useAuthentication();
  const history = useHistory();
  const { hash } = useLocation();
  const token = useToken();
  const [isLoading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!authenticated) {
      setLoading(true);
      if (hash) {
        const error = hash.includes('error');
        if (!error) {
          const data = hash.split('&');
          let idToken = data.find((item: string) => item.includes('id_token'));
          idToken = idToken.split('=');
          token.setToken(idToken[1]);

          let authState = data.find((item: string) => item.includes('state'));
          authState = authState.split('=');
          token.setState(authState[1]);
        }
      }

      setTimeout(() => {
        if (!authenticated) {
          history.push('/');
        } else {
          setLoading(false);
        }
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, history, hash, token]);

  const handleClick = () => {
    history?.push('/instructions');
  };

  return isLoading ? (
    <DefaultLayout>
      <div className="loading-container">
        <Loading />
      </div>
    </DefaultLayout>
  ) : (
    <SimpleLayout>
      <div className="home-container">
        <div className="home-container__info-group-wrapper">
          <InfoGroup
            title={<>Boas vindas à Trybe</>}
            description={
              <>
                Somos uma instituição financeira pertencente ao Grupo Trybe.
                Oferecemos financiamentos para dar acesso a uma educação de
                qualidade.
              </>
            }
            buttonName="Prosseguir"
            handleClick={handleClick}
          />
        </div>

        <div className="home-container__image">
          <img
            src="assets/images/menino-programando-foguete-trybe.svg"
            alt="Ilustração de um menino programando com um foguete da Trybe atrás, subindo através das nuvens"
          />
        </div>
      </div>
    </SimpleLayout>
  );
}

export default Home;
